"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CHANNEL_MAP = void 0;
exports.reportFtEvent = reportFtEvent;
const tslib_1 = require("tslib");
/*eslint-disable no-eq-null,eqeqeq */
const fego_render_1 = tslib_1.__importDefault(require("@futuweb/fego-render"));
const ft_report_1 = tslib_1.__importDefault(require("@futuweb/ft-report"));
/**
 * 事件上报
 * @param { string } eventName 事件名称
 * @param { object } property 事件属性
 * @param { number } eventVersion 事件版本
 * @returns { void }
 */
function reportFtEvent(eventName, property = {}, eventVersion = 1) {
    var _a, _b;
    try {
        if ((_b = (_a = fego_render_1.default === null || fego_render_1.default === void 0 ? void 0 : fego_render_1.default.plugins) === null || _a === void 0 ? void 0 : _a.ftReport) === null || _b === void 0 ? void 0 : _b.ftReportIns) {
            // 测试环境使用设置isTest为true并配置host：http://test.hosts.futuoa.com/hosts/get-hosts-content?id=10244
            // FEGORender.plugins.ftReport.ftReportIns.setOptions({
            //     isTest: true,
            // });
            fego_render_1.default.plugins.ftReport.ftReportIns.sdReport({
                eventName,
                eventVersion,
                eventEntity: ft_report_1.default.Entity.FUTUNN,
                payload: property,
            });
        }
    }
    catch (error) {
        console.error('error:', error);
    }
}
// channel分享上报映射值
exports.CHANNEL_MAP = {
    niuyou: '4',
    chatRoom: '6',
    nnq: '5',
    wxFriend: '0',
    wxTimeline: '1',
    qq: '2',
    weibo: '3',
    facebook: '7',
    twitter: '8',
    whatsapp: '9',
    dingtalk: '16',
    line: '17',
    telegram: '18',
    other: '10',
    instagram: '12',
    sms: '13',
    email: '14',
    copy: '15'
};
setTimeout(() => {
    let _window;
    if (window['Super_IPO_Season_click']) {
        return;
    }
    window['Super_IPO_Season_click'] = true;
    const actSign = 'Super_IPO_Season';
    const pageViwName = 'Super_IPO_Season_view';
    const pageViwName8s = 'Super_IPO_Season_view8s';
    const pageClickName = 'Super_IPO_Season_click';
    const getFtReport = (_window = window) == null
        || (_window = _window.FEGORender) == null ? void 0 : _window.getFtReport;
    if (!getFtReport) {
        return;
    }
    const ftReportIns = getFtReport();
    function getGlobalContent() {
        try {
            const url = new URL(location.href);
            const params = url.searchParams;
            const global_content_str = params.get('global_content') || '';
            return global_content_str;
        }
        catch (e) {
            console.error('解析global_content失败', e);
            return '';
        }
    }
    function reportClick() {
        ftReportIns == null || ftReportIns.sdReport({
            eventName: 'ClickPageEffectively',
            eventVersion: 3,
            eventEntity: 'NiuNiu',
            // entity -- 获取活动信息接口 entity字段 （FUTU_SG， FUTU_HK.....）
            payload: {
                union_id: pageClickName,
                act_sign: actSign,
                global_content: getGlobalContent()
            }
        });
    }
    function reportViewPage() {
        ftReportIns == null || ftReportIns.sdReport({
            eventName: 'ViewPageEffectively',
            eventVersion: 3,
            eventEntity: 'NiuNiu',
            // entity -- 获取活动信息接口 entity字段 （FUTU_SG， FUTU_HK.....）
            payload: {
                union_id: pageViwName,
                act_sign: actSign,
                global_content: getGlobalContent()
            }
        });
        setTimeout(() => {
            ftReportIns == null || ftReportIns.sdReport({
                eventName: 'ViewPageEffectively',
                eventVersion: 3,
                eventEntity: 'NiuNiu',
                // entity -- 获取活动信息接口 entity字段 （FUTU_SG， FUTU_HK.....）
                payload: {
                    union_id: pageViwName8s,
                    act_sign: actSign,
                    event_duration: 8000,
                    global_content: getGlobalContent()
                }
            });
        }, 8000);
    }
    reportViewPage();
    window.addEventListener('click', (event) => {
        const target = event.target;
        // 判断父节点与本节点是否有a标签
        // 判断父节点与本节点是否有fegoevt-n-click 属性
        // 判断是否是button
        if (target.tagName === 'A'
            || target.closest('a')
            || target.hasAttribute('fegoevt-n-click')
            || target.closest('[fegoevt-n-click]')
            || target.tagName === 'BUTTON'
            || target.closest('button')) {
            reportClick();
        }
    });
}, 300);
//# sourceMappingURL=data:application/json;base64,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